import React, { FC, useState } from 'react';
import { Modal } from 'Shared/components/Modal';
import { useHistory } from 'react-router-dom';
import { Button, Asset, CheckmarkIcon } from '@clearcover/atlas';
import { History } from 'history';

import styles from './styles.module.css';
import { formatDateMiddle } from 'Shared/utils';

export type SuccessModalType = {
  changeType: 'policy' | 'renewal' | 'draft';
};

export const SuccessModal: FC<SuccessModalType> = ({ changeType }) => {
  const [showModal, setShowModal] = useState(true);
  const history: History<{ effectiveDate?: string }> = useHistory();

  return (
    <>
      <Modal
        showModal={showModal}
        onClose={() => {
          setShowModal(!showModal);
          history.replace(history.location.pathname, {});
        }}
        className={styles.successModal}
        disableCurtainClick
      >
        <div
          data-testid="policy-change-success-modal"
          className={styles.successModalContainer}
        >
          <div className={styles.checkIcon}>
            <Asset
              description="Policy Change Success Modal"
              className={styles.checkmarkIcon}
              icon={CheckmarkIcon}
              height={30}
              width={30}
            />
          </div>
          <div className={styles.successModalHeader}>
            {changeType === 'renewal'
              ? 'Renewal Term Updated'
              : 'Policy Updated'}
          </div>
          <p className={styles.modalText}>
            {changeType === 'policy'
              ? `Changes have successfully been applied to the policy and go into effect on ${formatDateMiddle(
                  history.location.state?.effectiveDate ?? ''
                )}`
              : `Changes have successfully been applied to the ${
                  changeType === 'renewal' ? 'renewal term' : 'policy'
                }.`}
          </p>
          <Button
            className={styles.okayButton}
            data-testid="success-modal-okay"
            size={'md'}
            variant="primary"
            onClick={() => {
              setShowModal(!showModal);
              history.replace(history.location.pathname, {});
            }}
          >
            OKAY
          </Button>
        </div>
      </Modal>
    </>
  );
};
